"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
exports.default = Routes;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const component_1 = __importDefault(require("@loadable/component"));
const styled_components_1 = require("styled-components");
const react_router_dom_1 = require("react-router-dom");
const Cookies = __importStar(require("js-cookie"));
const react_ga_1 = __importDefault(require("@src/helpers/react-ga"));
const gtm_1 = __importDefault(require("@src/helpers/gtm"));
const types_1 = require("@src/types");
const Analytics = __importStar(require("@src/helpers/analytics-tracking"));
const Main_1 = require("@src/components/layouts/Main");
const home_1 = require("@src/components/pages/home");
// import { ApplicantsCalculator } from '@src/components/pages/microsite/applicants-calculator'
const contact_1 = require("@src/components/pages/contact");
const protection_1 = __importDefault(require("@src/components/pages/protection"));
const terms_and_conditions_1 = __importDefault(require("@src/components/pages/terms-and-conditions"));
const login_1 = require("@src/components/pages/login");
const registration_1 = require("@src/components/pages/registration");
const registration_candidate_1 = require("@src/components/pages/registration-candidate");
const authenticated_registration_warning_1 = require("@src/components/pages/authenticated-registration-warning");
const reset_password_1 = require("@src/components/pages/reset-password");
const reset_password_email_1 = __importDefault(require("@src/components/pages/reset-password-email"));
const offer_notification_subscription_1 = require("@src/components/pages/offer-notification-subscription");
const not_found_1 = __importDefault(require("@src/components/pages/not-found"));
const candidate_1 = require("@src/components/pages/candidate");
const companies_1 = require("@src/components/pages/companies");
const recruitment_1 = require("@src/components/pages/recruitment");
const offers_1 = require("@src/components/pages/offers");
const magazine_1 = __importDefault(require("@src/components/pages/magazine"));
const post_1 = __importDefault(require("@src/components/pages/magazine/post"));
const homepage_1 = __importDefault(require("@src/components/pages/magazine/homepage"));
const offer_detail_1 = require("@src/components/pages/offer-detail");
const candidate_feedback_1 = __importDefault(require("@src/components/pages/candidate-feedback"));
const company_1 = require("@src/components/pages/company");
const theme_1 = require("@src/styles/theme");
const feature_switch_1 = __importDefault(require("@src/helpers/feature-switch"));
const notifications_section_1 = require("@src/components/modules/notifications-section");
const WelcomeFromPraxujPopup_1 = require("@src/components/modules/WelcomeFromPraxujPopup");
require("antd/dist/antd.less");
const react_router_1 = require("react-router");
const notification_context_1 = require("@src/context/notification-context");
const companies_list_1 = require("@src/components/pages/companies-list");
const premium_company_profile_1 = require("@src/components/pages/premium-company-profile");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const Admin = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin'))));
const AdminOffers = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/offers'))));
const HiringProcess = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/hiring-process'))));
const Applicants = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/applicants'))));
// const AutomatizedMessages = loadable(() => import('@src/components/pages/admin/modules/automatized-messages'))
const AdminOfferCreateOrEdit = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/offer-create-or-edit'))));
const AdminCredits = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/credits'))));
const AdminRecruitment = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/recruitment'))));
const AdminOrderPage = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/order/AdminOrderPage'))));
const AdminPayments = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/payments/Payments'))));
const AdminUsers = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/users/AdminUsers'))));
const CompanyInfoEdit = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/company-info-edit'))));
const AdminLoginInfoEdit = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/login-info-edit'))));
const AdminPersonalInfo = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/personal-info'))));
const BillingProfile = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/payments/billing-profile/BillingProfile'))));
const AdminApi = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/api/Api'))));
const AdminCompanyRemoval = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/company-removal/AdminCompanyRemoval'))));
const PaymentInformation = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/payment-information/PaymentInformationPage'))));
const AccountDeletionThankYou = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/account-deletion-thank-you/AccountDeletionThankYou'))));
const Profile = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile'))));
const ProfileApplicationHistory = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/ProfileApplicationHistory'))));
const ProfileLoginInfoEdit = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/settings'))));
const DeleteAccount = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/DeleteAccountSection'))));
const OfferNotificationSubscriptionSection = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/OfferNotificationSubscriptionSection'))));
const ProfileResumes = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/Resumes'))));
const ApplicantsProfile = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/resume/form'))));
const ApplicantResumeWebView = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/resume/web-view'))));
const SavedOffers = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/saved-offers/SavedOffers'))));
const Previews = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/analytics/Previews'))));
const Reports = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/analytics/Reports'))));
const Report = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/analytics/Reports/Report'))));
const PremiumCompanyProfile = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/premium-company-profile'))));
const AssetLibraryPage = (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('@src/components/pages/admin/modules/asset-library'))));
const applicantResumePaths = {
    sk: '/ucet/profil/uprava-profilu',
    en: '/account/profile/edit-profile',
};
const applicantResumeWebViewPaths = {
    sk: '/ucet/profil',
    en: '/account/profile',
};
const userProfileView = {
    sk: '/admin/uchadzaci/pouzivatel/:applicantProfileUuid',
    en: '/admin/applicants/user/:applicantProfileUuid',
};
// const adminAutomatizedMessagesPaths = {
// 	sk: featureSwitch('automatizedMessages') ? '/admin/automaticke-odpovede' : undefined,
// 	en: featureSwitch('automatizedMessages') ? '/account/automatized-messages' : undefined,
// }
const applicantsOverviewPaths = {
    sk: (0, feature_switch_1.default)('applicantsOverview') ? '/admin/uchadzaci' : undefined,
    en: (0, feature_switch_1.default)('applicantsOverview') ? '/admin/applicants' : undefined,
};
const routes = [
    {
        id: '/',
        Component: home_1.Home,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/',
            en: '/',
        },
        sitemap: true,
    },
    {
        id: '/verification',
        Component: home_1.Home,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/verification',
            en: '/verification',
        },
    },
    {
        id: '/offer_feedback',
        Component: home_1.Home,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/offer_feedback',
            en: '/offer_feedback',
        },
    },
    {
        id: '/zoznam-zamestnavatelov',
        Component: companies_list_1.CompaniesList,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/zoznam-zamestnavatelov',
            en: '/employers-list',
        },
        sitemap: true,
    },
    {
        id: '/premium-firemny-profil',
        Component: premium_company_profile_1.PremiumCompanyProfilePage,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/premium-firemny-profil',
            en: '/premium-company-profile',
        },
        sitemap: true,
    },
    {
        id: '/firmy',
        Component: companies_1.Companies,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/firmy',
            en: '/companies',
        },
        sitemap: true,
    },
    {
        id: '/firma',
        Component: company_1.PublicCompanyProfilePage,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/firma/:companyUniqueUrl/:content?',
            en: '/company/:companyUniqueUrl/:content?',
        },
    },
    {
        id: '/uchadzac',
        Component: candidate_1.Candidate,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/uchadzac',
            en: '/candidate',
        },
        sitemap: true,
    },
    {
        id: '/recruitment',
        Component: recruitment_1.Recruitment,
        props: {
            layout: 'main',
            navigation: {
                withHero: true,
            },
        },
        paths: {
            sk: '/recruitment',
            en: '/recruitment',
        },
        sitemap: true,
    },
    {
        id: '/kontakt',
        Component: contact_1.ContactUs,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/kontakt',
            en: '/contact',
        },
        sitemap: true,
    },
    {
        id: '/dakujeme-za-pouzivanie-nasej-platformy',
        Component: AccountDeletionThankYou,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/dakujeme-za-pouzivanie-nasej-platformy',
            en: '/thank-you-for-using-our-platform',
        },
    },
    {
        id: '/ochrana-osobnych-udajov',
        Component: protection_1.default,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/ochrana-osobnych-udajov',
            en: '/personal-data-protection',
        },
        sitemap: true,
    },
    {
        id: '/obchodne-podmienky',
        Component: terms_and_conditions_1.default,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/obchodne-podmienky',
            en: '/terms-and-conditions',
        },
        sitemap: true,
    },
    {
        id: '/ponuky',
        Component: offers_1.Offers,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/ponuky/:page?',
            en: '/offers/:page?',
        },
    },
    {
        id: '/ponuka',
        Component: offer_detail_1.OfferDetailsPage,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/ponuka/:slug',
            en: '/offer/:slug',
        },
    },
    {
        id: '/prihlasenie',
        Component: login_1.Login,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/prihlasenie',
            en: '/login',
        },
        sitemap: true,
    },
    {
        id: '/registracia',
        Component: registration_1.Registration,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/registracia',
            en: '/registration',
        },
        sitemap: true,
    },
    {
        id: '/registracia-uchadzac',
        Component: registration_candidate_1.RegistrationCandidate,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/registracia-uchadzac',
            en: '/registration-candidate',
        },
        sitemap: true,
    },
    {
        id: '/registracia-prihlaseny-pouzivatel',
        Component: authenticated_registration_warning_1.AuthenticatedRegistrationWarning,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/registracia-prihlaseny-pouzivatel',
            en: '/authenticated-registration-warning',
        },
    },
    {
        id: '/obnovenie-hesla',
        Component: reset_password_1.ResetPassword,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/obnovenie-hesla',
            en: '/reset-password',
        },
    },
    {
        id: '/obnovenie-hesla-email',
        Component: reset_password_email_1.default,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/obnovenie-hesla-email',
            en: '/reset-password-email',
        },
    },
    {
        id: '/odber',
        Component: offer_notification_subscription_1.OfferNotificationSubscriptionPage,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/odber',
            en: '/offer-subscription',
        },
    },
    {
        id: '/feedback/:feedbackToken',
        Component: candidate_feedback_1.default,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/feedback/:feedbackToken',
            en: '/feedback/:feedbackToken',
        },
    },
    {
        id: '/ucet',
        Component: Profile,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/ucet',
            en: '/account',
        },
        routes: [
            {
                id: '/ucet',
                Component: ProfileApplicationHistory,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet',
                    en: '/account',
                },
            },
            {
                id: '/ucet/ulozene-ponuky',
                Component: SavedOffers,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/ulozene-ponuky',
                    en: '/account/saved-offers',
                },
            },
            {
                id: '/ucet/prihlasovacie-udaje',
                Component: ProfileLoginInfoEdit,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/prihlasovacie-udaje',
                    en: '/account/login-info',
                },
            },
            {
                id: '/ucet/odber',
                Component: OfferNotificationSubscriptionSection,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/odber',
                    en: '/account/subscription',
                },
            },
            {
                id: '/ucet/zivotopisy',
                Component: ProfileResumes,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/zivotopisy',
                    en: '/account/resumes',
                },
            },
            {
                id: '/ucet/profil',
                Component: ApplicantResumeWebView,
                props: {
                    layout: 'main',
                },
                paths: applicantResumeWebViewPaths,
            },
            {
                id: '/ucet/profil/uprava-profilu',
                Component: ApplicantsProfile,
                props: {
                    layout: 'main',
                },
                paths: applicantResumePaths,
            },
            {
                id: '/ucet/notifikacie',
                Component: notifications_section_1.NotificationsSection,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/notifikacie',
                    en: '/account/notifications',
                },
            },
            {
                id: '/ucet/vymazanie-uctu',
                Component: DeleteAccount,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/ucet/vymazanie-uctu',
                    en: '/account/delete-account',
                },
            },
        ],
    },
    {
        id: '/admin',
        Component: Admin,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/admin',
            en: '/admin',
        },
        routes: [
            {
                id: '/admin',
                Component: AdminOffers,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin',
                    en: '/admin',
                },
            },
            {
                id: '/admin/vyberovy-proces',
                Component: HiringProcess,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/vyberovy-proces/:offerId?',
                    en: '/admin/hiring-process/:offerId?',
                },
            },
            {
                id: '/admin/uchadzaci',
                Component: (0, feature_switch_1.default)('applicantsOverview') ? Applicants : undefined,
                props: {
                    layout: 'main',
                },
                paths: applicantsOverviewPaths,
            },
            {
                id: '/admin/uchadzaci/pouzivatel',
                Component: ApplicantResumeWebView,
                props: {
                    layout: 'main',
                },
                paths: userProfileView,
            },
            {
                id: '/admin/kredity',
                Component: AdminCredits,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/kredity',
                    en: '/admin/credits',
                },
            },
            {
                id: '/admin/recruitment',
                Component: AdminRecruitment,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/recruitment',
                    en: '/admin/recruitment',
                },
            },
            {
                id: '/admin/objednavka',
                Component: AdminOrderPage,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/objednavka',
                    en: '/admin/order',
                },
            },
            {
                id: '/admin/objednavka/platobne-informacie',
                Component: PaymentInformation,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/objednavka/platobne-informacie/:invoiceId',
                    en: '/admin/order/payment-informations/:invoiceId',
                },
            },
            {
                id: '/admin/firemny-profil',
                Component: CompanyInfoEdit,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/firemny-profil',
                    en: '/admin/company-profile',
                },
            },
            {
                id: '/admin/platby',
                Component: AdminPayments,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/platby',
                    en: '/admin/payments',
                },
            },
            {
                id: '/admin/platby/fakturacny-profil',
                Component: BillingProfile,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/platby/fakturacny-profil/:billingProfileId?',
                    en: '/admin/paymets/billing-profile/:billingProfileId?',
                },
            },
            {
                id: '/admin/api',
                Component: AdminApi,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/api',
                    en: '/admin/api',
                },
            },
            {
                id: '/admin/odstranenie-udajov-spolocnosti',
                Component: AdminCompanyRemoval,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/odstranenie-udajov-spolocnosti',
                    en: '/admin/remove-company-data',
                },
            },
            {
                id: '/admin/pouzivatelia',
                Component: AdminUsers,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/pouzivatelia',
                    en: '/admin/users',
                },
            },
            {
                id: '/admin/osobne-udaje',
                Component: AdminPersonalInfo,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/osobne-udaje',
                    en: '/admin/personal-information',
                },
            },
            {
                id: '/admin/prihlasovacie-udaje',
                Component: AdminLoginInfoEdit,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/prihlasovacie-udaje',
                    en: '/admin/login-information',
                },
            },
            {
                id: '/admin/pridat-ponuku',
                Component: AdminOfferCreateOrEdit,
                props: {
                    layout: 'main',
                    offerAction: types_1.OfferAction.create,
                },
                paths: {
                    sk: '/admin/pridat-ponuku',
                    en: '/admin/add-offer',
                },
            },
            {
                id: '/admin/uprava-ponuky',
                Component: AdminOfferCreateOrEdit,
                props: {
                    layout: 'main',
                    offerAction: types_1.OfferAction.edit,
                },
                paths: {
                    sk: '/admin/uprava-ponuky/:slug',
                    en: '/admin/edit-offer/:slug',
                },
            },
            {
                id: '/admin/notifikacie',
                Component: notifications_section_1.NotificationsSection,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/notifikacie',
                    en: '/admin/notifications',
                },
            },
            {
                id: '/admin/kniznica',
                Component: AssetLibraryPage,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/kniznica',
                    en: '/admin/library',
                },
            },
            // This is commented to get rid of browser warnings when featureSwitch is off (false)
            // {
            // 	id: '/admin/automaticke-odpovede',
            // 	Component: featureSwitch('automatizedMessages') ? AutomatizedMessages : undefined,
            // 	props: {
            // 		layout: 'main',
            // 	},
            // 	paths: adminAutomatizedMessagesPaths,
            // },
            {
                id: '/admin/prehlady',
                Component: Previews,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/prehlady',
                    en: '/admin/previews',
                },
            },
            {
                id: '/admin/reporty',
                Component: Reports,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/reporty',
                    en: '/admin/reports',
                },
            },
            {
                id: '/admin/reporty',
                Component: Report,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/reporty/:analyticsType',
                    en: '/admin/reports/:analyticsType',
                },
            },
            {
                id: '/admin/premium-firemny-profil',
                Component: PremiumCompanyProfile,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/admin/premium-firemny-profil',
                    en: '/admin/premium-company-profile',
                },
            },
        ],
    },
    {
        id: '/magazin',
        Component: magazine_1.default,
        props: {
            layout: 'main',
        },
        paths: {
            sk: '/magazin',
            en: '/magazine',
        },
        routes: [
            {
                id: '/magazin',
                Component: homepage_1.default,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/magazin',
                    en: '/magazine',
                },
            },
            {
                id: '/magazin/archiv/:page',
                Component: homepage_1.default,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/magazin/archiv/:page',
                    en: '/magazine/archive/:page',
                },
            },
            {
                id: '/magazin/:slug',
                Component: post_1.default,
                props: {
                    layout: 'main',
                },
                paths: {
                    sk: '/magazin/:slug',
                    en: '/magazine/:slug',
                },
            },
        ],
        sitemap: true,
    },
    // microsites
    // {
    // 	id: '/kalkulacka-poctu-uchadzacov',
    // 	Component: ApplicantsCalculator,
    // 	layout: 'microsite',
    // 	paths: {
    // 		sk: '/kalkulacka-poctu-uchadzacov',
    // 		en: '/estimate-number-of-responses',
    // 	},
    // },
    // {
    // 	id: '/vianocny-darcek',
    // 	Component: ChristmasCampaign,
    // 	layout: 'microsite',
    // 	paths: {
    // 		sk: '/vianocny-darcek/:plan',
    // 		en: '/christmas-present/:plan',
    // 	},
    // },
];
exports.routes = routes;
function getRoutePaths(routeObject) {
    const paths = Object.entries(routeObject.paths).map(([locale, path]) => locale !== 'sk' ? `/${locale}${path}` : path);
    const Component = routeObject.Component;
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: paths, exact: !routeObject.routes, children: routeObject.routes ? ((0, jsx_runtime_1.jsx)(Component, { ...routeObject.props, children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [routeObject.routes.map(innerRoute => getRoutePaths(innerRoute)), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { children: (0, jsx_runtime_1.jsx)(not_found_1.default, {}) })] }) })) : ((0, jsx_runtime_1.jsx)(Component, { ...routeObject.props })) }, paths[0]));
}
function Routes() {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const topLevelMainLayoutRoutes = routes.filter(({ props }) => props.layout === 'main');
    const micrositeLayoutRoutes = routes.filter(({ props }) => props.layout === 'microsite');
    const { value: NotificationValue, NotificationContextProvider } = (0, notification_context_1.useNotificationContextProvider)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    react_1.default.useEffect(() => {
        if (process.env.NODE_ENV === 'production') {
            // init google analytics
            react_ga_1.default.initialize(process.env.GOOGLE_ANALYTICS);
        }
        gtm_1.default.initialize();
    }, []);
    react_1.default.useEffect(() => {
        window.scrollTo(0, 0);
        // Google analytics
        react_ga_1.default.pageview(location.pathname + location.search);
        // inhouse tracking
        Analytics.trackPageView();
        Analytics.trackPromotedOfferView();
    }, [location.pathname]);
    react_1.default.useEffect(() => {
        const sessionId = history.getQuery().sid;
        if (sessionId) {
            Cookies.set('connect.sid', sessionId);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            history.replace(window.location.pathname);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [micrositeLayoutRoutes.map(routeObject => getRoutePaths(routeObject)), (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: theme_1.theme, children: (0, jsx_runtime_1.jsxs)(NotificationContextProvider, { value: NotificationValue, children: [(0, jsx_runtime_1.jsx)(WelcomeFromPraxujPopup_1.WelcomeFromPraxujPopup, {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { children: (0, jsx_runtime_1.jsx)(Main_1.LayoutMain, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [topLevelMainLayoutRoutes.map(routeObject => getRoutePaths(routeObject)), (0, jsx_runtime_1.jsx)(react_router_1.Redirect, { from: "/profil", to: "/ucet" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "*", children: (0, jsx_runtime_1.jsx)(not_found_1.default, {}) })] }) }) })] }) })] }));
}
